import { BASE_URL } from "../static/constants";

const SET_PATIENT_ENROLL_DATA = "SET_PATIENT_ENROLL_DATA";
const SET_PATIENT_ACTIVE_DATA = "SET_PATIENT_ACTIVE_DATA";
const SET_USER_BILLING_DATA = "SET_USER_BILLING_DATA";

function setPatientEnrollData(data) {
  return {
    type: SET_PATIENT_ENROLL_DATA,
    data,
  };
}

function setPatientActiveData(data) {
  return {
    type: SET_PATIENT_ACTIVE_DATA,
    data,
  };
}

function setBillingData(data) {
  return {
    type: SET_USER_BILLING_DATA,
    data,
  };
}

export function enrollPatient(payload) {
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/v2/patient/enroll`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        return dispatch(setPatientEnrollData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}

export function disablePatient(serialNumber) {
  const payload = {
    serialNumber,
  };
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/patient/deactivate`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        return dispatch(setPatientActiveData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}

export function enablePatient(serialNumber) {
  const payload = {
    serialNumber,
  };
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/patient/activate`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        return dispatch(setPatientActiveData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}

export function updateSchedule(payload) {
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/patient/updateschedule`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        return dispatch(setBillingData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}
